import inputSources from '../data/input-sources.json';

// Matches Profiler's inputDisplayName() using its Input Selection catalog paths.
const displayNames = new Map(inputSources.map((input) => [input.decoderLabel, input.displayName]));

export function inputSourceDisplayName(value: string): string {
  return displayNames.get(value) ?? value;
}
